import { useState } from "react";
import { Star, Loader2, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function Stars({ value, onPick, size = "h-5 w-5", testid }) {
  return (
    <span className="inline-flex gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} onClick={onPick ? () => onPick(n) : undefined} data-testid={onPick ? `${testid}-${n}` : undefined}
          className={`${size} transition-transform ${onPick ? "cursor-pointer hover:scale-110" : ""} ${n <= Math.round(value || 0) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      ))}
    </span>
  );
}

export function RateJob({ path, initial, who, testid }) {
  const [stars, setStars] = useState(initial || 0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(!!initial);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.post(path, { stars, comment }); setDone(true); toast.success("Thanks for rating your professional"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 bg-amber-50/60 border border-amber-200 rounded-lg p-4" data-testid={testid} onClick={(e) => e.stopPropagation()}>
      <div className="text-sm font-semibold text-slate-900">{done ? "Your rating" : `How did ${who || "your professional"} do?`}</div>
      <div className="mt-2"><Stars value={stars} onPick={done ? undefined : setStars} testid={`${testid}-stars`} /></div>
      {!done && stars > 0 && <>
        <Textarea rows={2} maxLength={1000} className="mt-3 bg-white" placeholder="Optional: what went well or could be better? Only the GrantVerify team sees this." value={comment} onChange={(e) => setComment(e.target.value)} data-testid={`${testid}-comment`} />
        <Button size="sm" disabled={busy} onClick={save} className="mt-2 bg-slate-900 hover:bg-slate-800" data-testid={`${testid}-submit`}>{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Submit rating</Button>
      </>}
      {done && <p className="text-xs text-slate-500 mt-1">Shared privately with the GrantVerify team. <button onClick={() => setDone(false)} className="text-emerald-700 font-semibold hover:underline" data-testid={`${testid}-edit`}>Edit</button></p>}
    </div>
  );
}

export function TopRatedTag({ testid }) {
  return <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-amber-800 bg-amber-100 border border-amber-300 rounded-full px-2 py-0.5" data-testid={testid}><Award className="h-3 w-3" />Top rated</span>;
}
